export default __webpack_public_path__ + "static/media/use_action_back3.f584bf9b.png";